import {Model} from 'vue-mc';
//import { boolean , equal , integer , min , required , string , and , length , alphanumeric } from 'vue-mc/validation';

export class ParametrosModel extends Model{
  // Default attributes that define the "empty" state.
  defaults() {
    return {
        clave : 1
      , horarioConversionInicio: ""
      , horarioConversionFin: ""
      , horarioDescargaInicio: ""
      , horarioDescargaFin: ""
      , dias: 0
      , summiterID: ""
      , urlBuzonSFTP : ""
      , usuarioBuzonSFTP : ""
      , passwordBuzonSFTP: ""
      , puertoBuzonSFTP : ""
      , seguridadHabilitadaZIP: true
      , passwordZIP: ""
      , numeroIntentos: 0
    }
  }

  // Attribute mutations.
  mutations() {
    return {
      clave:clave=>clave
      , horarioConversionInicio:horarioConversionInicio=>horarioConversionInicio
      , horarioConversionFin:horarioConversionFin=>horarioConversionFin
      , horarioDescargaInicio:horarioDescargaInicio=>horarioDescargaInicio
      , horarioDescargaFin:horarioDescargaFin=>horarioDescargaFin
      , dias:dias=>dias
      , summiterID:summiterID=>summiterID
      , urlBuzonSFTP : urlBuzonSFTP => urlBuzonSFTP
      , usuarioBuzonSFTP : usuarioBuzonSFTP => usuarioBuzonSFTP
      , passwordBuzonSFTP : passwordBuzonSFTP => passwordBuzonSFTP
      , puertoBuzonSFTP : puertoBuzonSFTP => puertoBuzonSFTP
      , seguridadHabilitadaZIP : seguridadHabilitadaZIP=> seguridadHabilitadaZIP
      , passwordZIP : passwordZIP=> passwordZIP
      , numeroIntentos : numeroIntentos=> numeroIntentos
    }
  }

  // Attribute validation
  validation() {
    return {
    }
  }

  // Model Options
  options() {
    return {
      validateOnSave     : false
      , validateOnChange   : false 
      , validateRecursively: false
    }
  }

}



// WEBPACK FOOTER //
// ./src/models/generales/parametros.js